
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/hooks/use-toast";
import { getBelgianCandidates } from "./sampleData";

export const generateBelgianCandidateData = async (): Promise<void> => {
  try {
    // Get the user's organization UUID
    const { data: userOrgData } = await supabase.auth.getSession();
    const userUuid = userOrgData.session?.user?.id;
    
    let organizationUuid = null;
    
    if (userUuid) {
      const { data: userOrg } = await supabase
        .from('user_organization')
        .select('organization_uuid')
        .eq('user_uuid', userUuid)
        .single();
        
      organizationUuid = userOrg?.organization_uuid;
    }
    
    const belgianCandidates = getBelgianCandidates();
    
    // Insert candidates in batches to avoid timeouts
    const batchSize = 10;
    const totalCandidates = belgianCandidates.length;
    let insertedCount = 0;

    toast({
      title: "Adding Candidates",
      description: `Adding ${totalCandidates} Belgian candidates to the database...`,
    });

    for (let i = 0; i < totalCandidates; i += batchSize) {
      const batch = belgianCandidates.slice(i, i + batchSize);
      
      // Add organization_uuid to each candidate
      const batchWithOrg = batch.map(candidate => ({
        ...candidate,
        organization_uuid: organizationUuid
      }));
      
      const { data, error } = await supabase
        .from('candidates')
        .insert(batchWithOrg);
      
      if (error) {
        console.error("Error inserting batch:", error);
        throw error;
      }
      
      insertedCount += batch.length;
      
      toast({
        title: "Progress",
        description: `Added ${insertedCount} of ${totalCandidates} candidates`,
      });
    }

    toast({
      title: "Success",
      description: `Successfully added ${insertedCount} Belgian candidates to the database`,
    });

    return;
  } catch (error) {
    console.error("Error generating candidate data:", error);
    toast({
      title: "Error",
      description: "Failed to generate candidate data",
      variant: "destructive",
    });
    throw error;
  }
};
